export default __webpack_public_path__ + "static/media/Home3.eaff19c5.png";